<template>
  <div>
    <h2 class="step-name">Beef Parasite Management</h2>

    <div class="step-section">
      <discussion-points
        title="Discussion"
        comments-field="beef_parasite_management_discussion"
        points="&lt; 15 months old - need levamisole to kill Cooperia effectively, &gt; 15 months old - MLs kill most worms, Lice, Young stock"
      >
      </discussion-points>

      <div class="form-group">
        <span class="form-group">
          <label>Internal Parasite</label>
          <comments field-name="internal_parasite"></comments>
        </span>
      </div>

      <div class="form-group">
        <span class="form-group">
          <label>External Parasite</label>
          <comments field-name="external_parasite"></comments>
        </span>
      </div>

      <radio-input
        label="Do you want an animal health plan / calendar"
        :add-email-notification="true"
        field-name="beef_wants_health_plan"
        @on-change="toggleNotifications"
        :add-comment="true"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>
    </div>

    <div class="step-section">
      <h3>Drench Product Purchases</h3>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Date</th>
            <th>Animal Name</th>
            <th>Stock Code - Name</th>
            <th>Quantity</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in getChartData('beef_drench_purchases')" :key="index">
            <td class="text-left">{{ row['Date'] }}</td>
            <td class="text-left">{{ row['Animal Name'] }}</td>
            <td class="text-left">{{ row['Stock Code - Name'] }}</td>
            <td class="text-left">{{ row['Quantity'] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'

export default {
  name: 'BeefParasiteManagement',
  mixins: [baseComponent],
  methods: {
    toggleNotifications: function () {
      this.setEmailNotification({
        slug: 'beef-wants-health-plan',
        value: this.getFieldValue('beef_wants_health_plan', this.$options.name) == 'Yes',
      })
    },
  },
}
</script>
